import React from 'react';
import LottieAnimation from '@/v2/components/behaviours/LottieAnimation';
import Icon from '@/v2/components/atoms/Icon';
import animationData from './LottieTap.json';

const Tap = (props) => (
    <Icon iconName="Tap" {...props}>
        <LottieAnimation loop autoplay animationData={animationData} />
    </Icon>
);

export default Tap;
